import { OTA_POS } from "./ota_pos.model";
import { OTA_VehResRQCore } from "./ota_vehresrqcore.model";
import { OTA_VehResRQInfo } from "./ota_vehresrqinfo.model";

export class OTA_VehResRQ {
    public pos = new OTA_POS();
    public vehResRQCore = new OTA_VehResRQCore();
    public vehResRQInfo = new OTA_VehResRQInfo();
}
